import React, { FC } from 'react';
import { AnalyticsLoaderProps } from './AnalyticsLoaderProps';
import { LoadingBall } from '@ingka/loading';
import { Box } from '@mui/system';

const AnalyticsLoader: FC<AnalyticsLoaderProps> = ({ loading, children }) => {
  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {loading && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            pointerEvents: 'none',
            zIndex: 1,
          }}
        >
          <LoadingBall />
        </Box>
      )}
      {children}
    </Box>
  );
};

export default AnalyticsLoader;
